import { createFileRoute, Navigate } from '@tanstack/react-router';

import { useAbility } from '@features/authorization';
import {
  CustomerDocumentCreateForm,
  CustomerDocumentFullPageAccessGate,
} from '@features/crm-customer-documents';
import { canAccessCrmCustomerDocuments } from '@shared/lib';
import { firstAccessibleCrmCustomerRecordArea } from '@widgets/crm-customer-record-shell';

export const Route = createFileRoute(
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/documents/new'
)({
  component: CreateCustomerDocumentRoute,
});

function CreateCustomerDocumentRoute() {
  const navigate = Route.useNavigate();
  const { userProfileId: customerId, locale } = Route.useParams();
  const search = Route.useSearch();
  const ability = useAbility();
  if (!canAccessCrmCustomerDocuments(ability))
    return <Navigate to="/$locale/unauthorized" params={{ locale }} replace />;
  return (
    <main className="min-w-0 p-4 sm:p-6">
      <CustomerDocumentFullPageAccessGate
        customerId={customerId}
        onAccessUnavailable={(allowedAreas) => {
          const fallback = firstAccessibleCrmCustomerRecordArea(allowedAreas);
          return (
            <Navigate
              to={fallback?.route ?? '/$locale/unauthorized'}
              params={{ userProfileId: customerId, locale }}
              replace
            />
          );
        }}
      >
        {(viewerAccessScope) => (
          <CustomerDocumentCreateForm
            customerId={customerId}
            initialDocumentType={
              search.documentType === 'paper-completion-form' ? 'paper-completion-form' : undefined
            }
            initialRegistrationId={search.documentRegistrationId}
            viewerAccessScope={viewerAccessScope}
            onBack={() => {
              void navigate({
                to: '/$locale/crm/user-profiles/$userProfileId/documents',
                params: { userProfileId: customerId, locale },
                search: {
                  documentRegistrationId: search.documentRegistrationId,
                  documentType: search.documentType,
                },
              });
            }}
            onCreated={(documentId) => {
              void navigate({
                replace: true,
                to: '/$locale/crm/user-profiles/$userProfileId/documents/$documentId',
                params: { userProfileId: customerId, documentId, locale },
                search: { learningRegistrationId: search.documentRegistrationId },
              });
            }}
          />
        )}
      </CustomerDocumentFullPageAccessGate>
    </main>
  );
}
